<template>
  <b-button  class='card-challenges-event' style="pointer-events: none; cursor: default !important">
    <b-card header-tag="header" footer-tag="footer">

      <template v-slot:header class="d-flex">
        <div class="title">
          <PuSkeleton :loading="isLoading" :count="1" width="200px">
            <h5 class="uppercase blue">
                {{title}}
            </h5>
          </PuSkeleton>
          <PuSkeleton :loading="isLoading" :count="1" width="100px">                
            <h6>
                {{subtitle}}
            </h6>
          </PuSkeleton>
        </div>
      </template>


      <b-card-text>
        <div class="left">
        
          <div class="top">
            <PuSkeleton :loading="isLoading" :count="1" width="200px">
              <span>
                <i class="far fa-calendar-alt"></i>
                <div class="title">{{content.labelStart}}</div>
              </span>
              <div class="date">{{ startDate | moment(true) }}</div>
            </PuSkeleton>
          </div>
        
          <div class="bottom">
            <PuSkeleton :loading="isLoading" :count="1" width="200px">
              <span>
              <i class="far fa-calendar-alt"></i>
                <div class="title">{{content.labelEnd}}</div>
              </span>
              <div class="date">{{ endDate | moment(true) }}</div>    
            </PuSkeleton>
          </div>
        
        </div>


        <div class="right">
          <PuSkeleton :loading="isLoading" :count="1" width="120px">                    
            <font-awesome-icon :icon="['far', 'bullseye-arrow']" />
            <div class="cible">
              <p class="title">{{content.labelTarget}}</p>
              <div class="number">
                  {{objectiveNumber}}
              </div>
            </div>
          </PuSkeleton>
        </div>
      </b-card-text>


        <div class="line">
          <p class="inprogress">
            <PuSkeleton :loading="isLoading" :count="1" width="120px">                  
              {{inprogress}}
            </PuSkeleton>
          </p>
          <PuSkeleton :loading="isLoading" :count="1">
            <b-progress height="0.5625rem" :value="50">
            </b-progress>
          </PuSkeleton>
        </div>            
      <template v-slot:footer>
        <div class="deadline">
          <PuSkeleton :loading="isLoading" :count="1" width="100px" height="20px">                                  
            {{content.dayOf}}{{deadline}}
          </PuSkeleton>  
        </div>
        <div class="state">
          <PuSkeleton :loading="isLoading" :count="1" width="100px" height="20px">                 
            <span v-if="state === 'progress'">EN cours</span>                  
            <span v-else-if="state === 'done'">Terminé</span>   
          </PuSkeleton>
        </div>   
      </template>
    </b-card>
  </b-button>

</template>


<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
moment.locale('fr');
//
export default {
  name: "CardChallengesCommercials",
  components:{ 
  },
  props:{
    id:{
      type:String,
    },
    title:{
      type:String,
      default:'Pura Vida'
    },
    subtitle:{
      type:String,
      default:'Chiffre d’affaire AN'
    }, 
    objectiveNumber:{
      type:Number,
      default:110000
    },
    startDate:{
      type:String,
      default:'04/04/2020'
    },
    endDate:{
      type:String,
      default:'04/05/2020'
    },
    inprogress:{
      type:Number,
      default:56000
    },
    // deadline:{
    //   type:String,
    //   default:'45'
    // },
    state:{
      type:String,
      default:'en cours'
    },
    isLoad:{
      type:Boolean,
      default: true
    },  
  },
  data(){
    return {  
      content:{},  
      isLoading:true,
      deadline:0,      
    }
  },
  computed: {
    ...mapGetters([
      'getGeneral',
    ]),
  },
  created (){
    this.content = this.getGeneral;
    this.isLoading = this.isLoad;  
    //
    const start = moment(this.startDate).format('L');
    const end = moment(this.endDate).format('L');
    this.deadline = this.getDaysDiff(start, end); 
  },
  methods:{
    moment: function (date,year) {
      return moment(date,year);
    }, 
    getDaysDiff: function (start_date, end_date, date_format = 'YYYY-MM-DD') {
      const getDateAsArray = (date) => {
        return moment(date.split(/\D+/), date_format);
      }
      return getDateAsArray(end_date).diff(getDateAsArray(start_date), 'days') + 1;
    },
    progress : function(target,current){
      let result;
      result = Math.round((current/target)*100);
      return result;
    },    
    updateInfo : function(){
      // console.log('UPDATE INFO');
      this.$store.dispatch('setChallengeUpdated',this.id);
      this.$root.$emit('bv::show::modal', 'form-challenge', '#btnShow');
    }        
  },
  filters: {
    moment: function (date,year) {
      let $format = !year ? 'Do MMMM': 'Do/MM/YYYY';
      return moment(date).format($format);
    }
  },   
  watch : {
    'isLoad' : function (){
      this.isLoading = this.isLoad;    
    },
  },     
}
</script>
